const ENV = process.env.REACT_APP_ENV ?? "development";

export const isDev = ENV === "development";
export const isStaging = ENV === "staging";
export const isProd = ENV === "production";

export const x_staging_key = isStaging
  ? process.env.REACT_APP_STAGING_SECRET
  : "";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE ?? "";

if (!API_BASE_URL) {
  throw new Error("API_BASE_URL is not defined");
}
